import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../../lib/motion";

// A prominent transitional banner that funnels visitors from the free
// download experience into the paid packages. Sits between LeadMagnet
// and Pricing in the landing composition.
export default function PackagesBanner() {
    return (
        <section
            className="relative border-b border-hairline bg-ink text-white"
            data-testid="packages-banner"
        >
            <div className="mx-auto grid max-w-[1400px] gap-8 px-5 py-16 lg:grid-cols-12 lg:items-center lg:gap-12 lg:px-10 lg:py-20">
                <div className="lg:col-span-8">
                    <Reveal>
                        <div className="mb-3 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.3em] text-coral">
                            <span className="h-px w-8 bg-coral" />
                            Ready for hands-on help?
                        </div>
                        <h2
                            className="font-display text-4xl font-black leading-[0.98] tracking-tight sm:text-5xl lg:text-6xl"
                            data-testid="packages-banner-headline"
                        >
                            Loved the checklist?{" "}
                            <span className="font-serif italic font-normal text-coral">
                                We&apos;ll do the doing.
                            </span>
                        </h2>
                        <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/80 lg:text-lg">
                            Three plain-English packages designed for small businesses in NZ &amp;
                            AU. Month-to-month. No 12-month lock-ins. Pick the one that fits
                            where you are right now.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-4 lg:justify-self-end">
                    <Reveal>
                        <a
                            href="#pricing"
                            className="group inline-flex items-center gap-3 border-2 border-coral bg-coral px-8 py-5 font-display text-base font-bold uppercase tracking-wider text-white transition-all hover:-translate-y-1 hover:frame lg:text-lg"
                            data-testid="packages-banner-cta"
                        >
                            View the 3 packages
                            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
